export default __webpack_public_path__ + "static/sfx-bg_4-e4672b54ad968afe0f891dfcfc3b0028.png";